import React from "react"
import {
    AIModelForApp,
    getTotalPredictionCount,
    hasActiveAssignment
} from "../../../../../../../../Models/API/AIModel"
import { TableColumn } from "resha"
import { ActivityChart } from "./ActivityChart"
import { fromNow } from "../../../../../../../../Helpers/Functions/dateFormat"
import { AIModelUsageList } from "./AIModelUsageList"
import { AIModelStatus } from "./AIModelStatus"
import { AIModelActivenessToggleButton } from "../../Common/AIModelActivenessToggleButton"
import { Map } from "immutable"
import { metaAI } from "neql"

export function getColumnDefinitions(
    processingModelIds: Map<string, true>,
    toggleActiveness?: (modelId: string, value: boolean) => void,
    requestPrediction?: (modelId: string) => void
): TableColumn<AIModelForApp>[] {
    const columns: TableColumn<AIModelForApp>[] = [
        {
            headerClassName: "w-1/3",
            className: "text-smoke-610",
            renderHeader: () => "Model",
            render: ({ name, description, version }) => (
                <>
                    <p>
                        <span className="font-bold text-grape-800 mr-1">
                            {name}
                        </span>
                        version {version}
                    </p>
                    <p className="truncate">{description}</p>
                </>
            )
        },
        {
            className: "hidden lg:table-cell text-smoke-810",
            headerClassName: "hidden lg:table-cell lg:w-56",
            renderHeader: () => "Predictions",
            render: model => {
                const count = getTotalPredictionCount(model).toLocaleString()

                return (
                    <div className="flex items-center justify-start">
                        <div className="w-12">{count}</div>
                        <div className="w-40">
                            <ActivityChart isSimple={true} model={model} />
                        </div>
                    </div>
                )
            }
        },
        {
            className: "text-smoke-810",
            renderHeader: () => "Used for",
            render: model => <AIModelUsageList model={model} />
        },
        {
            className: "text-smoke-810",
            renderHeader: () => "Last modified",
            render: ({ updatedAt, createdAt }) =>
                fromNow(updatedAt ?? createdAt)
        },
        {
            headerClassName: "w-24",
            className: "text-smoke-810",
            renderHeader: () => "Status",
            render: model => <AIModelStatus model={model} />
        }
    ]

    if (toggleActiveness !== undefined) {
        columns.push({
            headerClassName: "w-8",
            className: "text-smoke-800",
            renderHeader: () => null,
            render: model => {
                if (
                    model.deployment?.status ===
                        metaAI.Meta_Ai_Deployment_Status_Enum.Offline &&
                    model.deployment?.status !== model.deployment?.target_status
                ) {
                    return null
                }

                const isActive = hasActiveAssignment(model)
                const handleClick =
                    model.deployment?.status ===
                    metaAI.Meta_Ai_Deployment_Status_Enum.Offline
                        ? () => requestPrediction?.(model.id)
                        : toggleActiveness === undefined
                        ? undefined
                        : () => toggleActiveness(model.id, !isActive)

                return (
                    <AIModelActivenessToggleButton
                        size="md"
                        className="align-middle"
                        isActive={
                            model.deployment?.status ===
                                metaAI.Meta_Ai_Deployment_Status_Enum.Online &&
                            isActive
                        }
                        isProcessing={processingModelIds.has(model.id)}
                        onClick={handleClick}
                    />
                )
            }
        })
    }

    return columns
}
